module.exports = __webpack_public_path__ + "static/student-coach-qr-code-28da3749e42a04e29957e80098dd6b00.jpg";